import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"
import { Spacer } from "../atoms/Atoms"
import { SingleShorty, TwoColumnRow } from "./Shared"
import { ChangePasswordContext } from "../../containers/account/ChangePasswordContainer"
import L10n from "../../../lib/carrot-l10n"
import { Button } from "../atoms/buttons/Button"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const Footer = () => {
  const { toggleIsOpen, onSubmit } = useContext(ChangePasswordContext)
  const {
    formState: { isSubmitting }
  } = useFormContext()

  return (
    <>
      <div className="flex">
        <Button onClick={toggleIsOpen} outline>
          {l`cancel`}
        </Button>
        <Spacer width={1} />
        <ButtonPrimary onClick={onSubmit}>
          {isSubmitting ? <span>{l`client.submitting`}</span> : <span>{l`client.update`}</span>}
        </ButtonPrimary>
      </div>
      <Spacer height={2.125} />
    </>
  )
}

const CurrentPassword = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      name="currentPassword"
      type="password"
      label={l`client.accountSettings.currentPasswordLabel`}
      errors={errors}
      ref={register({
        required: l`client.accountSettings.currentPasswordRequired`
      })}
    />
  )
}

const NewPassword = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      type="password"
      name="newPassword"
      label={l`client.accountSettings.newPasswordLabel`}
      errors={errors}
      ref={register({
        required: l`client.accountSettings.newPasswordRequired`,
        minLength: {
          message: l`client.accountSettings.newPasswordMinLength`,
          value: 8
        }
      })}
    />
  )
}

const DisabledCurrentPassword = () => (
  <CompleteFormInput
    disabled
    defaultValue="•••••••••••••••••••••••••"
    label={l`client.accountSettings.currentPasswordLabel`}
  />
)

const ConfirmPassword = () => {
  const { errors, register, watch } = useFormContext()
  const newPassword = watch("newPassword")

  return (
    <CompleteFormInput
      type="password"
      name="confirmNewPassword"
      label={l`client.accountSettings.confirmPasswordLabel`}
      errors={errors}
      ref={register({
        required: l`client.accountSettings.confirmPasswordRequired`,
        validate: (value) => value === newPassword || l`Password must match`
      })}
    />
  )
}

const ChangePassword = () => (
  <>
    <SingleShorty>
      <CurrentPassword />
    </SingleShorty>
    <TwoColumnRow left={<NewPassword />} right={<ConfirmPassword />} />
    <Footer />
  </>
)

const ChangePasswordPreview = () => {
  const { toggleIsOpen } = useContext(ChangePasswordContext)

  return (
    <>
      <SingleShorty>
        <DisabledCurrentPassword />
      </SingleShorty>
      <SingleShorty>
        <Button onClick={toggleIsOpen} outline>
          {l`client.accountSettings.changePassword`}
        </Button>
        <Spacer height={0.75} />
      </SingleShorty>
    </>
  )
}

export { ChangePassword, ChangePasswordPreview }
